const Button = ({ children, className = "", ...props }) => {
  const defaultClasses = `flex w-full justify-center rounded-pill
    ${
      props.disabled
        ? "bg-ink-200 cursor-not-allowed"
        : "bg-accent-500 hover:bg-accent-600 active:scale-[0.99]"
    }
    px-4 py-2.5 text-sm font-medium leading-6 text-cream-50 tracking-[-0.005em]
    transition-[background-color,transform] duration-150 ease-editorial
    focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent-500
    ${props.disabled ? "opacity-70" : ""}`;

  return (
    <button className={`${defaultClasses} ${className}`} {...props}>
      {children}
    </button>
  );
};

export default Button;
